export const sentimentTrackerOnboardingConstants = {
    SENTIMENT_RESET_ONBOARDING_DATA: "SENTIMENT_RESET_ONBOARDING_DATA",
    SENTIMENT_UPDATE_ONBOARDING_DATA: "SENTIMENT_UPDATE_ONBOARDING_DATA",

    // TODO: move to master
    SENTIMENT_RISK_ASSESSMENT_API: "master/risk/assessment",

    // onboarding Data
    SENTIMENT_ONBOARDING_DATA_API: "sentiment/onboarding/details",
    SENTIMENT_ONBOARDING_DATA_SAGA: "SENTIMENT_ONBOARDING_DATA_SAGA",
    SENTIMENT_ONBOARDING_DATA_REQUEST: "SENTIMENT_ONBOARDING_DATA_REQUEST",
    SENTIMENT_ONBOARDING_DATA_RESPONSE: "SENTIMENT_ONBOARDING_DATA_RESPONSE",

    // STAGE 3
    SENTIMENT_CONFIRM_CKYC_DATA_API: "/onestock/onboarding/confirm-kyc",
    SENTIMENT_INITIATE_DOCUMENT_SIGNING_API: `sentiment/onboarding/initiate-signing`,
    SENTIMENT_DASHBOARD_REDIRECT_API :"sentiment/onboarding/redirection-sentiment"


};
